import { SelectionHandler } from "../../types";
import { DesignationSelectionHandler } from "../ConstraintsLayerType/DesignationSelectionHandler";
import { SubstationSelectionDetailView } from "./SubstationSelectionDetailView";

export const SubstationSelectionHandler: SelectionHandler = {
  ...DesignationSelectionHandler,
  SelectionDetailView: SubstationSelectionDetailView,
};
